class ChannelService {
  private code: string; // 渠道code 对应运营商渠道code
  private id: string; // 渠道ID 对应游戏即为gameCode
  private name: string; // 渠道名称 对应游戏即为游戏名称
  private tag: string; // 渠道标识 对应运营商渠道标识

  public get channelCode() {
    return this.code;
  }

  public set channelCode(code: string) {
    this.code = code;
  }

  public get gameCode() {
    return this.id;
  }

  public set gameCode(id: string) {
    this.id = id;
  }

  public get channelName() {
    return this.name;
  }

  public set channelName(name: string) {
    this.name = name;
  }

  public get channelTag() {
    return this.tag;
  }

  public set channelTag(tag: string) {
    this.tag = tag;
  }
}

const channelService = new ChannelService();
export default channelService;
